import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  paper: {
    [theme.breakpoints.up('sm')]: {
      paddingInlineStart: 385,
    },
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
  },
  imageWrapper: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    insetInlineStart: 0,
    width: 385,
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  title: {
    [theme.breakpoints.up('sm')]: {
      paddingInlineStart: 48,
    },
    '& > h2': {
      display: 'flex',
      justifyContent: 'space-between',
      [theme.breakpoints.up('sm')]: {
        fontSize: 24,
      },
      fontWeight: 700,
    },
  },
  subtitle: {
    fontSize: 16,
    fontWeight: 700,
  },
  contentText: {
    fontSize: 16,
    marginTop: 8,
    paddingTop: 10,
    borderTop: '1px solid #D9D9D9',
  },
  input: {
    '& > label': {
      fontWeight: 700,
    },
  },
  content: {
    [theme.breakpoints.up('sm')]: {
      paddingInlineStart: 48,
    },
  },
  actions: {
    paddingInlineEnd: 24,
    paddingBottom: 24,
    paddingInlineStart: 24,
    [theme.breakpoints.up('sm')]: {
      paddingInlineStart: 48,
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      rowGap: 12,
      '& > button': {
        width: '100%',
      },
    },
  },
}));
